import { DepositRequirementSource } from '@principle-theorem/principle-core/interfaces';

/**
 * Exhaustive mapping of DepositRequirementSource to display label.
 * TypeScript enforces all enum members are present.
 *
 * `TreatmentConfiguration` and `TreatmentTemplate` are named in full rather
 * than collapsed to "Treatment". They are configured in different places, and
 * a receptionist told only "Treatment" cannot tell which setting to go and
 * change when the amount looks wrong.
 */
export const DEPOSIT_SOURCE_LABELS: Record<DepositRequirementSource, string> = {
  [DepositRequirementSource.None]: 'Unknown',
  [DepositRequirementSource.Patient]: 'Patient',
  [DepositRequirementSource.Staff]: 'Added by staff',
  [DepositRequirementSource.TreatmentConfiguration]: 'Treatment Configuration',
  [DepositRequirementSource.TreatmentTemplate]: 'Treatment Template',
  [DepositRequirementSource.BookingContextExcluded]:
    'Not required for this booking type',
  [DepositRequirementSource.AppointmentDayExcluded]: 'Not required on this day',
};

/** Exhaustive mapping of DepositRequirementSource to its explanatory tooltip. */
export const DEPOSIT_SOURCE_TOOLTIPS: Record<DepositRequirementSource, string> =
  {
    [DepositRequirementSource.None]:
      'The reason for this deposit could not be determined.',
    [DepositRequirementSource.Patient]:
      'Required because this patient is flagged as needing a deposit.',
    [DepositRequirementSource.Staff]:
      'No rule required this deposit — a staff member added it to this appointment.',
    [DepositRequirementSource.TreatmentConfiguration]:
      'Required by the treatments selected for this appointment.',
    [DepositRequirementSource.TreatmentTemplate]:
      'Required by the treatment template for this appointment.',
    [DepositRequirementSource.BookingContextExcluded]:
      'No deposit is required for this type of booking.',
    [DepositRequirementSource.AppointmentDayExcluded]:
      'No deposit is required on this day of the week.',
  };
